import React from 'react';
import './App.css';
import Section from './components/sections/Section';
import SectionContact from './components/sections/contact/SectionContact';
import SectionPortfolio from './components/sections/portfolio/SectionPortfolio';
import SectionProfile from './components/sections/profile/SectionProfile';
import SectionResume from './components/sections/resume/SectionResume';
import { NavigationLevel } from './Utilities/NavigationUtility';
import Navbar from './components/Misc/Navbar';

function App() {
  return (
    <div>
      <Navbar />
      <Section
        childComp={<SectionProfile></SectionProfile>}
        navigationLevel={NavigationLevel.Home}>
      </Section>
      <Section
        childComp={<SectionPortfolio></SectionPortfolio>}
        navigationLevel={NavigationLevel.Portfolio}>
      </Section>
      <Section
        childComp={<SectionResume></SectionResume>}
        navigationLevel={NavigationLevel.Resume}>
      </Section>
      <Section
        childComp={<SectionContact></SectionContact>}
        navigationLevel={NavigationLevel.Contact}>
      </Section>
    </div>
  );
}

export default App;
